<!-- <p>form-field-dropdown-multiselect-v2 works!</p> -->
<!-- ***Designed by Rahul Kumar***** -->

<!-- Hello simple dropdown -->


<div class="dhl-form-field-dropdown-multiselect-v2" [formGroup]="frmGroup"
    [hidden]="frmGroup.get(configData.name)['hidden']" >
    <div class="form-field-wrapper">

        <label class="filter-label" *ngIf="configData['productType'] === 'FILTER' ">{{configData.label}}:</label>
        <div [ngClass]="{'filter-space': configData['productType'] === 'FILTER','new-filter-wrapper': configData['productType'] === 'NEW_FILTER','error': (frmGroup.get(configData.name).errors && frmGroup.get(configData.name).touched && !frmGroup.get(configData.name).valid) }" class="form-field-control" #formControl (click)="toggleDropdownList($event.target)">
            <select [formControl]="frmGroup.get(configData.name)" hidden [formControlName]="configData.name" class="hidden-form-control"
                [required]="configData.required">
                <option [value]=""></option>
                <option *ngFor="let option of configData.options" [value]="option">
                    {{option.displayValue}}</option>
            </select>

            <div #visibleFormControl class="visible-form-control" [ngClass]="{'filter-control': configData['productType'] === 'FILTER', 'focus': toggleList,'active': fieldControl.value || (configData.placeHolder && configData['productType'] === 'NEW_FILTER')}" title="{{fieldControl.value?.displayValue || configData.placeHolder}}">
                <div class="control-content" >
                    <span class="form-field-label">
                        <label class="base-label" *ngIf="configData['productType'] !== 'FILTER' ">
                            {{configData?.label}}<span *ngIf="configData?.required"> *</span>
                        </label>
                        <span *ngIf="fieldControl.value" class="form-field-value" title="{{returnMultiSelectValue()}}">
                            {{ returnMultiSelectValue()}}
                            <!-- {{fieldControl.value.displayValue}} -->
                        </span>
                        <span *ngIf="!fieldControl.value && configData['productType'] === 'NEW_FILTER'" class="form-field-value placeHolder">
                            {{configData.placeHolder || 'Please select...'}}
                        </span>
                    </span>
                    <span class="dropdown-icons" *ngIf="configData['productType'] !== 'FILTER' ">
                        <span class="disabled-icon" hidden>
                            <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,1442,20,20))"
                                style="width:20px;height:20px" type="image/svg+xml" />
                        </span>
                        <span [ngClass]="{'show': toggleList}" class="active-icon">
                            <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,120,24,24))"
                                style="width:20px;height:20px" type="image/svg+xml" />
                        </span>
                        <span [ngClass]="{'hide': (toggleList || fieldControl.value)}" class="normal-icon">
                            <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,90,24,24))"
                                style="width:20px;height:20px" type="image/svg+xml" />
                        </span>
                        <span [ngClass]="{'show': fieldControl.value || configData['productType'] === 'NEW_FILTER', 'open': toggleList}" class="filled-icon">
                            <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,180,24,24))"
                                style="width:20px;height:20px" type="image/svg+xml" />
                        </span>
                    </span>
                </div>

            </div>
            <span class="default-icon" style="display: inline-flex;" *ngIf="configData['productType'] === 'FILTER' ">
                <img  src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,210,24,24))" style="width:24px;height:24px" type="image/svg+xml" />
            </span>
            <div #visibleDropdownList class="visible-dropdown-list" [ngClass]="{'hide-border': !toggleList, 'filter-list': configData['productType'] === 'FILTER'}">
                <ng-container  *ngIf="toggleList">
                    <div title="{{option.displayValue}}" [ngClass]="{'filter-item': configData['productType'] === 'FILTER'}" *ngFor="let option of configData.options" class="visible-dropdown-item">
                        <div style="width: calc(100% - 55px);align-items: center;display: flex;">
                            <span class="checkbox-container" (click)="selectedOption($event, option, checkbox)">
                                <input #checkbox type = "checkbox" [checked]="option['checked'] === true ">
                            </span>
                            <span class="text-container">
                                {{option.displayValue }}
                            </span>
                        </div>                        
                        <div style="width: 55px;cursor: pointer;" *ngIf="option['onlySelection'] === true && (configData['productType'] === 'FILTER' || configData['productType'] === 'NEW_FILTER')" (click)="selectOnlyThisOption($event, option, checkbox)">
                            <span>
                                <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,2310,58,32))" style="width:58px;height:32px" type="image/svg+xml"/>
                            </span>
                        </div>
                    </div>
                </ng-container>
            </div>

        </div>

        <div class="form-field-error"
            [ngClass]="{'hide-error': !(frmGroup.get(configData.name).errors && (frmGroup.get(configData.name).touched || frmGroup.get(configData.name).value) && !frmGroup.get(configData.name).valid)}">
            <span class="error-icon">
                <img class="dhl-input-error-icon"
                    src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
            </span>

            <span class="error-text" *ngIf="frmGroup.get(configData.name).errors">
                <span *ngIf="frmGroup.get(configData.name).errors.required">Required</span>
            </span>
        </div>
    </div>
</div>
